var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcRec = function SvgIcRec(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_rec")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_rec",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,25 C5.59644063,25 8.45442189e-16,19.4035594 0,12.5 C-8.45442189e-16,5.59644063 5.59644063,1.26816328e-15 12.5,0 C19.4035594,-1.26816328e-15 25,5.59644063 25,12.5 C24.988988,19.3989929 19.3989929,24.988988 12.5,25 L12.5,25 Z M12.5,2 C6.70101013,2 2,6.70101013 2,12.5 C2,18.2989899 6.70101013,23 12.5,23 C18.2989899,23 23,18.2989899 23,12.5 C22.9944872,6.70329514 18.2967049,2.0055128 12.5,2 Z",
    id: "Shape",
    fill: "#31549B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "recording_dot",
    d: "M16.5,12.5 C16.5,10.290861 14.709139,8.5 12.5,8.5 C10.290861,8.5 8.5,10.290861 8.5,12.5 C8.5,14.709139 10.290861,16.5 12.5,16.5 C14.709139,16.5 16.5,14.709139 16.5,12.5 Z",
    id: "Path",
    fill: "#DB2B45"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcRec, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_rec.3a5f5568.svg";
export { ForwardRef as ReactComponent };